import {
  RecognitionSection,
  RecognitionTitle
} from "./style";

import RecognitionCarousel from "../RecognitionCarousel";


const RecognitionComponent = () => {

  return (
    <RecognitionSection id="Reconhecimento">
      <RecognitionTitle>Reconhecimentos</RecognitionTitle>
      <RecognitionCarousel />
    </RecognitionSection>
  );
};

export default RecognitionComponent;
